import { render, staticRenderFns } from "./FactoryMaterialSearcher.vue?vue&type=template&id=513df50c&scoped=true&"
import script from "./FactoryMaterialSearcher.vue?vue&type=script&lang=js&"
export * from "./FactoryMaterialSearcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513df50c",
  null
  
)

export default component.exports